
<template>
    <div class="flow-graph-container">
        <svg
            class="flow-graph"
            :width="width"
            :height="height"
        >
            <defs>
                <!-- 成功icon ✅ -->
                <polygon
                    id="successIcon"
                    points="-2.00 2.80 -4.80 0.00 -5.73 0.933 -2.00 4.67 6.00 -3.33 5.07 -4.27"
                />
                <!-- 失败icon ❎-->
                <polygon
                    id="failureIcon"
                    points="4.67 -3.73 3.73 -4.67 0 -0.94 -3.73 -4.67 -4.67 -3.73 -0.94 0 -4.67 3.73 -3.73 4.67 0 0.94 3.73 4.67 4.67 3.73 0.94 0"
                />
                <!-- 感叹号icon -->
                <g
                    id="exclamationIcon"
                >
                    <polygon points="-1 -5 1 -5 1 1 -1 1" />
                    <polygon points="-1 3 1 3 1 5 -1 5" />
                </g>
                <!-- 暂停icon ⏸ -->
                <g
                    id="pausedIcon"
                >
                    <polygon points="-4,-4.65 -4,4.65 -4,4.65 -1.5,4.65 -1.5,-4.65" />
                    <polygon points="4,-4.65 1.5,-4.65 1.5,-4.65 1.5,4.65 4,4.65" />
                </g>
                <!-- 用户icon -->
                <svg
                    id="userIcon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                ><path
                    d="M914.286 802.89q0 68.534-41.692 108.25T761.71 950.858H262.29q-69.12 0-110.884-39.716T109.714 802.89q0-30.281 1.975-59.172t7.973-62.318 15.14-62.025 24.576-55.735 35.401-46.3 48.86-30.573 63.707-11.41q5.12 0 23.991 12.287t42.57 27.429 61.732 27.429 76.288 12.288 76.288-12.288 61.732-27.429 42.57-27.429 23.99-12.288q34.89 0 63.708 11.41t48.86 30.574 35.4 46.3 24.576 55.735 15.141 62.025 7.973 62.318 1.974 59.172zM731.429 292.57q0 90.844-64.293 155.136T512 512t-155.136-64.293-64.293-155.136 64.293-155.136T512 73.143t155.136 64.292 64.293 155.136z"
                /></svg>

            </defs>
            <node-line
                v-for="(item,index) in lineList"
                :key="'line'+index"
                :path="item.path"
                :weight="item.weight"
            />
            <node
                v-for="(item,idx) in nodeList"
                :key="'node'+idx"
                :status="item.status"
                :label="item.name"
                :x="item.x"
                :y="item.y"
                :virtual="item.virtual"
                :highlight="item.highlight"
                :node="item"
                :index="idx"
                @click="handleClick"
                @mouseenter="handleMouseEnter"
                @mouseleave="handleMouseLeave"
                @text-mouseenter="handleTextMouseEnter"
                @text-mouseleave="handleTextMouseLeave"
            />
        </svg>
        <Tooltip
            :visible.sync="visible"
            v-bind="tooltipProps"
        />
    </div>
</template>
<script>
import Node from './Node';
import NodeLine from './Line.vue';
import { FlowGraph } from './service';
import Tooltip from './Tooltip';

export default {
    name: 'XxFlowGraph',
    components: {
        Node,
        NodeLine,
        Tooltip,
    },
    props: {
    // 第一个点的起始位置
        x: {
            type: Number,
            default: 50,
        },
        // 第一个点的y座标
        y: {
            type: Number,
            default: 55,
        },
        // x轴上相邻两个点之间的距离
        xstep: {
            type: Number,
            default: 120,
        },
        // y 轴上相邻两个点之间的距离
        ystep: {
            type: Number,
            default: 50,
        },
        data: {
            type: Array,
            default: () => [],
            required: true,
        },
        tooltipClass: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            nodeList: [],
            width: 0,
            height: 0,
            lineList: [],
            service: {},
            visible: false,
            tooltipProps: {
                content: '',
                position: { x: 0, y: 0 },
                className: this.tooltipClass,
            },
        };
    },
    computed: {
        dataLength() {
            return this.data.length;
        },
    },
    watch: {
        data() {
            this.render();
        }
    },
    mounted() {
        this.render();
    },
    methods: {
        handleClick(node) {
            this.$emit('select', node);
        },
        handleMouseEnter(index, node) {
            this.$emit('mouseenter', node);
        },
        handleMouseLeave(index, node) {
            this.$emit('mouseleave', node);
        },
        handleTextMouseEnter(textObj) {
            const { content, left, top } = textObj;
            this.tooltipProps.content = content;
            this.tooltipProps.position = { left, top };
            this.visible = true;
        },
        handleTextMouseLeave() {
            this.visible = false;
        },
        render() {
            this.service = new FlowGraph(
                this.data,
                this.x,
                this.y,
                this.xstep,
                this.ystep,
            );
            if (this.service.hasCircle()) {
                throw new Error('Error data, The graph should not contain any circle!');
            }
            this.service.calculateAllPosition();
            this.nodeList = this.service.nodes;
            this.lineList = this.service.getLines();
            this.width = this.service.width;
            this.height = this.service.height;
        },
    },
};
</script>

<style >
.flow-graph-container {
    width: 100%;
    overflow-x: auto;
}

.flow-graph .weight-no-audit {
  fill: rgb(233, 233, 233);
  stroke: rgb(233, 233, 233);
}

.flow-graph .weight-failure,
.flow-graph .weight-error {
  fill: rgb(246, 42, 25);
  stroke: rgb(246, 42, 25);
}

.flow-graph .weight-pending {
  fill: rgb(134, 134, 134);
  stroke: rgb(134, 134, 134);
}

.flow-graph .weight-success,
.flow-graph .weight-current {
  fill: rgb(104, 208, 130);
  stroke: rgb(104, 208, 130);
}

/* .flow-graph .flow-graph-node{
  transform: rotate(90deg)
} */
.flow-graph-node-terminal {
  fill: #949393;
}
.flow-graph-connector-skipped {
  stroke: #949393;
  stroke-opacity: 0.25;
}
.flow-graph-small-label {
  font-size: 80%;
}
.flow-graph-big-label.selected,
.flow-graph-small-label.selected {
  font-weight: bold;
}
.flow-graph-selection-highlight circle {
  fill: none;
  stroke: #4a90e2;
}
.flow-graph-selection-highlight circle.white-highlight {
  stroke: white;
}

.flow-graph-node-terminal {
  fill: #949393;
}
.svgResultStatus.no-background .circle-bg {
  opacity: 0;
}

.jdl-table td .svgResultStatus {
  vertical-align: middle;
}

.flow-graph-big-label.selected,
.flow-graph-small-label.selected {
  font-weight: bold;
}
</style>
